export const formatPrice = (val) => {
  const formatedItemTotalPrice = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'RSD',
  })
    .format(val)
    .replace('RSD', '')
    .replace(/\.00$/, '') // Only removes trailing .00
    .trim(); // Remove any extra spaces

  return formatedItemTotalPrice;
};

// export const formatPrice = (val) => {
//   return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
// };

// Function for formating numbers (currency text stripped, plain decimal only)
export const formatPriceWithCurrency = (value) => {
  const formatedItemTotalPrice = new Intl.NumberFormat('de-DE', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })
    .format(value)
    .trim();

  return formatedItemTotalPrice;
};
